import { Inject, Injectable } from '@angular/core';
import { TBAppEnvironmentVars } from '@monorepo/types';

const TechpackUploadEndpoints = {
  GET_FILTERS_DROPDOWN_DATA: 'GET_FILTERS_DROPDOWN_DATA',
  GET_STYLES_BY_BUYER: 'GET_STYLES_BY_BUYER',
  GET_BUYERS_BY_STYLE: 'GET_BUYERS_BY_STYLE',
  GET_TECHPACK_UPLOADS_LISTING: 'GET_TECHPACK_UPLOADS_LISTING',
  VIEW_TECHPACK: 'VIEW_TECHPACK',
  UPLOAD_TECHPACK: 'UPLOAD_TECHPACK',
  DELETE_TECHPACK: 'DELETE_TECHPACK',
};

type TTechpackUploadEndpoints = typeof TechpackUploadEndpoints;
type TTechpackUploadEndpointsTypes = keyof TTechpackUploadEndpoints;
type TEnvVariables = TTechpackUploadEndpoints;

@Injectable({
  providedIn: 'root',
})
export class TechpackUploadEnvProvider {
  private env_vars!: TEnvVariables;
  private protocol = 'http';
  private service_host = '';
  private techpack_upload_services = '';

  constructor(@Inject('environment') environment: TBAppEnvironmentVars) {
    if (environment.protocol != null) {
      this.protocol = environment.protocol;
    }
    if (environment.service_host != null) {
      this.service_host = environment.service_host;
    }
    if (environment.core_services != null) {
      this.techpack_upload_services = environment.core_services;
    }
    this.registerVars();
  }

  registerVars() {
    const HOST = this.protocol + this.service_host + this.techpack_upload_services;
    const baseURL = 'api/v1';

    this.env_vars = {
      GET_FILTERS_DROPDOWN_DATA: `${HOST}/${baseURL}/buyersAndStylesFilter`, // :factoryId
      GET_STYLES_BY_BUYER: `${HOST}/${baseURL}/stylesFilter`, // :factoryId/:buyer
      GET_BUYERS_BY_STYLE: `${HOST}/${baseURL}/buyersFilter`, // :factoryId/:style
      GET_TECHPACK_UPLOADS_LISTING: `${HOST}/${baseURL}/orderListingByGroupBctx`,
      VIEW_TECHPACK: `${HOST}/${baseURL}/downloadTechPack`,
      UPLOAD_TECHPACK: `${HOST}/${baseURL}/uploadTechPackFile`,
      DELETE_TECHPACK: `${HOST}/${baseURL}/deleteTechPack`,
    };
  }

  getEnvVar(key: TTechpackUploadEndpointsTypes): string {
    return this.env_vars[key];
  }
}
